export default __webpack_public_path__ + "38c6d8bab26db77d8c806813e1497763.woff2";